(() => {
  const ensureModal = () => {
    let modal = document.getElementById('cqv-modal');

    // If markup isn't present yet (or missing), create it.
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cqv-modal';
      modal.className = 'cqv-modal';
      modal.hidden = true;

      modal.innerHTML = `
        <div class="cqv-modal__backdrop" data-cqv-close></div>
        <div class="cqv-modal__panel" role="dialog" aria-modal="true" aria-label="Quick view">
          <button type="button" class="cqv-modal__close" data-cqv-close aria-label="Close">✕</button>
          <div class="cqv-modal__content" data-cqv-content></div>
        </div>
      `;

      document.body.appendChild(modal);
    }

    return modal;
  };

  const init = () => {
    console.log('CQV init');

    const modal = ensureModal();
    const content = modal.querySelector('[data-cqv-content]');
    if (!content) return;

    const openModal = () => {
      modal.hidden = false;
      document.documentElement.classList.add('cqv-open');
      document.body.classList.add('cqv-open');
    };

    const closeModal = () => {
      modal.hidden = true;
      content.innerHTML = '';
      document.documentElement.classList.remove('cqv-open');
      document.body.classList.remove('cqv-open');
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cqv-close]')) closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });

    document.addEventListener(
      'click',
      async (e) => {
        const btn = e.target.closest('[data-cqv-open]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const handle = btn.getAttribute('data-product-handle');
        if (!handle) return;

        btn.classList.add('is-loading');

        try {
          const url = `/products/${handle}?section_id=clarus-main-product-quick-view`;
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          const html = await res.text();

          content.innerHTML = html;
          openModal();
          // Force Flickity to recalc now that modal is visible
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // 1) Kick layout
              window.dispatchEvent(new Event('resize'));

              // 2) Resize any Flickity instances inside the injected content
              content.querySelectorAll('.flickity-enabled').forEach((el) => {
                const flkty = window.Flickity?.data?.(el);
                if (flkty) {
                  flkty.resize();
                  flkty.reposition();
                  flkty.select(flkty.selectedIndex || 0, false, true);
                }
              });

              // 3) If images are still loading, do a second pass shortly after
              setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
                content.querySelectorAll('.flickity-enabled').forEach((el) => {
                  const flkty = window.Flickity?.data?.(el);
                  if (flkty) {
                    flkty.resize();
                    flkty.reposition();
                  }
                });
              }, 150);
            });
          });

        } catch (err) {
          console.error('CQV load failed', err);
        } finally {
          btn.classList.remove('is-loading');
        }
      },
      true
    );
  };

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
